import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useEffect, useState } from "react";

import styled from "@emotion/styled";

const StyledDiv = styled.div`
  .coupon-carroussel-container {
    /* border: 2px solid purple; */
    width: fit-content;
    margin: 0 auto;
    font-size: 1.2rem;
    font-weight: 500;
  }
`;

const messageList = [
  "💙 Equipe de saúde dedicada.",
  "💙 Cuidado com a Saúde Mental.",
  "💙 Consultas remotas ilimitadas.",
  "💙 Atendimento 24/7.",
  "💙 Plano de cuidados individual.",
  "💙 Histórico eletrônico da sua saúde.",
  "💙 Indicadores de bem-estar.",
  "💙 Receitas, guias de exames e atestados, tudo digital.",
  "💙 Sem carência, sem fidelidade, sem surpresas.",
  "💙 E muito acolhimento!",
];

const CouponCarroussel: React.FC = () => {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds((seconds) => seconds + 1);
    }, 2500);
    return () => clearInterval(interval);
  }, []);

  const messageComponents = messageList.map((message, idx) => {
    return (
      <motion.p
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: +20, opacity: 0 }}
        key={idx}
      >
        {message}
      </motion.p>
    );
  });

  return (
    <StyledDiv>
      <div className="coupon-carroussel-container">
        <AnimatePresence mode="wait">
          {messageComponents[seconds % messageComponents.length]}
        </AnimatePresence>
      </div>
    </StyledDiv>
  );
};

export default CouponCarroussel;
